var map = {
	"./audio1.mp4": 790,
	"./audio2.mp4": 673,
	"./audio3.mp4": 276,
	"./audio4.mp4": 999,
	"./audio5.mp4": 338,
	"./audio6.mp4": 549,
	"./audio7.mp4": 376,
	"./audio8.mp4": 328,
	"./audio9.mp4": 534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;